import React from 'react';

import { TravelDetails as TravelDetailsModel } from 'models/travelDetails';

import Item from './components/Item';
import { Container } from './styles';

export interface Props {
  data: TravelDetailsModel;
}

const TravelTimeline = ({ data }: Props) => (
  <Container>
    {data.travelLogs.reverse().map((item, index) => (
      <Item
        key={index.toString()}
        travelLog={item}
        travelDetails={data}
        noSeparator={index === data.travelLogs.length - 1}
      />
    ))}
  </Container>
);

export default TravelTimeline;
